import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface PromptEditModalProps {
  prompt: string;
  onPromptChange: (prompt: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export default function PromptEditModal({
  prompt,
  onPromptChange,
  onClose,
  onConfirm
}: PromptEditModalProps) {
  const { t } = useTranslation('editor');

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg w-full max-w-3xl max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h3 className="text-lg font-medium text-gray-200">{t('common.editPrompt')}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-200 transition-colors"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 p-4 overflow-y-auto">
          <textarea
            value={prompt}
            onChange={(e) => onPromptChange(e.target.value)}
            className="w-full h-full min-h-[300px] bg-gray-900 text-gray-200 text-sm resize-none outline-none placeholder-gray-500 rounded-lg p-3"
            placeholder={t('common.promptPlaceholder')}
            autoFocus
          />
        </div>
        <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-700">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-400 hover:text-gray-200 transition-colors"
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
          >
            {t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
